function createMiddleware(middleware) {
  return middleware;
}
export {
  createMiddleware
};
//# sourceMappingURL=createMiddleware.js.map
